import type { ReactNode } from 'react';
import { useCan } from '@/lib/rbac/can';
import { ForbiddenPage } from './error-page';

/**
 * Route-level permission gate (any-of). A defence-in-depth companion to the nav
 * filtering — a user who deep-links to a route they lack permission for gets a 403
 * page, not a broken screen. The backend guards remain the authoritative gate.
 */
export function RequirePermission({ permission, children }: { permission: string | string[]; children: ReactNode }) {
  const perms = Array.isArray(permission) ? permission : [permission];
  return useCan(...perms) ? <>{children}</> : <ForbiddenPage />;
}
